// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7451d5f2","977":"628a4baf"}[chunkId] + ".chunk.js";
};